import './App.scss'
import '@aws-amplify/ui-react/styles.css'
import { IconButton, Menu, MenuItem } from '@mui/material'
import { Menu as MenuIcon } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import React, { useState } from 'react'
import { Airport } from './airports/Airport'

interface Props {
  airports: Airport[]
  selectedAirportIcao?: string
}

const AirportsMenu = ({ airports }: Props) => {
  const navigate = useNavigate()
  const [anchorEl, setAnchorEl] = useState<HTMLElement | undefined>(undefined)
  const open = Boolean(anchorEl)

  const handleClose = (airportIcao?: string) => {
    setAnchorEl(undefined)
    if (airportIcao) {
      navigate(airportIcao)
    }
  }

  return (
    <>
      <IconButton
        size="large"
        edge="start"
        color="inherit"
        aria-label="menu"
        sx={{ mr: 2, display: { md: 'none' } }}
        onClick={(event) => {
          setAnchorEl(event.currentTarget)
        }}
      >
        <MenuIcon />
      </IconButton>
      <Menu id="basic-menu" anchorEl={anchorEl} open={open} onClose={() => handleClose()}>
        {airports.map((airport) => (
          <MenuItem key={airport.icao} onClick={() => handleClose(airport.icao)} sx={{ minWidth: 150 }}>
            {airport.name}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

export default AirportsMenu
